import React, { useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import Header from "./Header";
import { ROUTE_BASE_URL } from "../../api/common";
import axios from "axios";
import { baseUrl } from "../../api/common";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Footer from "./Footer";
import { encryptSlug } from "../../util/encryption";
const UserMemberApplicationNotFound = () => {

    const history = useHistory();
    const [formValues, setFormValues] = useState ({
      email: '',
      mobile: ''
    });

    const [errors, setErrors] = useState ({
      email: '',
      mobile: ''
    });

    const validate = () => {
    const errors = {
        email: '',
        mobile: ''
    }
    // if (!formValues.email) {
    //   errors.email = 'Email ID cannot be empty';
    // } 
    if (!/\S+@\S+\.\S+/.test (formValues.email.trim()) && formValues.email.trim()) {
      errors.email = 'Email ID is invalid';
    }
    // if (!formValues.mobile) {
    //   errors.mobile = 'Mobile Number cannot be empty';
    // } 
    if (!/^\d{10}$/.test (formValues.mobile.trim()) && formValues.mobile.trim()) {
      errors.mobile = 'Mobile Number must be 10 digits';
    }
    setErrors(errors)
    return Object.values(errors).every((error) => error === "")
  }
  const handleInputChange = (field, value) => {
    setFormValues ({...formValues, [field]: value});
  };
  const clearFormValues = () => {
    setFormValues ({
      email: '',
      mobile: ''
    });
    setErrors ({
      email: '',
      mobile: ''
    });
  }
	const trackApplication = async ()=> {
        if (formValues.email.trim() === '' && formValues.mobile.trim() === '') {
          showToast("Please enter at least one of the fields: Email ID or Mobile Number", "error");
          return;
        }
		if(!validate()) {
		  return;	
		}
		try {
			const response = await axios.post(
			  `${baseUrl}/api/know_membership`,
			  formValues,
			  {
				headers: {
				  "Content-Type": "application/json",
				  Authorization: localStorage.getItem("access_token"),
				},
			  }
			);	  
			if (response.data.status) {
              clearFormValues();
              history.replace(`${ROUTE_BASE_URL}/know-user-member-application/${encryptSlug(`${response.data.data[0].id}`)}`);
			} else {
              showToast(response.data.message, "error");
			}
		  } catch (error) {
			console.error("Error during submission:", error);
		}    
	}

    return (
        <>
            <ToastMessage />
            <section className="user_div_total">
                <Header/>
                <div className="container pt-50">
                    <div className="row heaight_div_app">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="body border_radius_10">
                                    <div className="header appli_header">
                                        <h4>Know your AMASI Membership Number</h4>
                                    </div>
                                        <div className="form-group pos_relative">
                                            <label>Registered Email ID</label>
                                            <input
                                                type="email"
                                                placeholder="example@email.com"
                                                className={`form-control ${errors.email ? 'red_border' : ''}`}
                                                value={formValues.email} 
                                                onChange={e =>
                                                handleInputChange ('email', e.target.value)}
                                            />
                                          {errors &&
                                            <p className="text-danger pos_abos">
                                            {errors.email}
                                            </p>}
                                        </div>
                                        <p>OR</p>
                                        <div className="form-group pos_relative">
                                            <label>Registered Phone Number</label>
                                            <input
                                                type="number"
                                                placeholder="1234567890"
                                                className={`form-control ${errors.mobile ? 'red_border' : ''}`}
                                                value={formValues.mobile} 
                                                onChange={e =>
                                                handleInputChange ('mobile', e.target.value)}
                                            />
                                           {errors &&
                                            <p className="text-danger pos_abos">
                                            {errors.mobile}
                                            </p>}
                                        </div>
                                        <div>
                                            <button onClick={()=>trackApplication()}  className="btn btn-primary w-100">Submit</button>
                                        </div>
                                        <div className="pt-20 text-center">
                                          <p className="font-size-16">
                                          Enter your registered contact details to find your AMASI membership number 
                                         </p>
                                        </div>
                                      <div className="text-center support_div_not_found"> 
                                        <p><small>Supported formats:</small></p>
                                        <p><small>Email: user@example.com</small></p>
                                        <p><small>Phone: 1234567890</small></p>  
                                      </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
                <Footer/>
            </section>
        </>
    );

}


export default UserMemberApplicationNotFound
